import React, { FC } from "react";

interface Props {
  icon: string;
  iconName: string;
  onClick?: () => void;
}

const ActionButton: FC<Props> = ({ icon, iconName, onClick }) => {
  return (
    <button
      className="size-6 flex items-center justify-center"
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick && onClick();
      }}
    >
      <img src={icon} alt={iconName} className="size-2/3" />
    </button>
  );
};

export default ActionButton;
